import { render, staticRenderFns } from "./AccountDetailsTab.vue?vue&type=template&id=3193c4d0&scoped=true&"
import script from "./AccountDetailsTab.vue?vue&type=script&lang=js&"
export * from "./AccountDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3193c4d0",
  null
  
)

export default component.exports